import http from '../util/ws/wsService'

class UserService {
    routeApi = "user";

    async getAll(page, limit, search, searchFields) {
        if (search && search.length > 0 && searchFields && searchFields.length > 0) {
            return await this.search(searchFields, search, page, limit);
        }
        return await http.get(this.routeApi, { page, limit });
    }

    async updateUserBasic(userId,userName,code){
        return await http.put(this.routeApi , { userId, userName,code });
    }
    async updateEnvironments(userId, environmentIds) {

        return await http.put(this.routeApi + "/update-environments", { userId, environmentIds });
    }

    async updateRegTypes(userId, regTypeIds) {
        return await http.put(this.routeApi + "/update-regTypes", { userId, regTypeIds });
    }

    async updateResources(userId, resourceIds) {
        return await http.put(this.routeApi + "/update-resources", { userId, resourceIds });
    }
    async search(fields, search, page, limit) {
        fields = fields.toString()
        return await http.get(this.routeApi + "/search-fields", { fields, search, page, limit });
    }
    async delete(id) {
        return await http.delete('user', id);
    }

}






export default new UserService()